<template>
  <div class="rounded-full">
    <img :title="title || countryCode" :src="src" :alt="countryCode" />
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  countryCode: { type: String, default: "Earth" },
  languageCode: { type: String, required: false },
  title: { type: String, required: false },
});

const languageCodeToCountryCodeMap = {
  cs: "CZ",
  da: "DK",
  el: "GR",
  en: "GB",
  et: "EE",
  ja: "JP",
  sl: "SI",
  sv: "SE",
  uk: "UA",
  zh: "CN",
};

const src = computed(() => {
  let countryCode = props.countryCode;
  if (props.languageCode) {
    countryCode =
      languageCodeToCountryCodeMap[props.languageCode] || props.languageCode;
  }
  return `/images/flags/${countryCode.toUpperCase()}.svg`;
});
</script>
